import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/service/auth.service';
import { DashBoardService } from 'src/app/service/dashboard.service';
import { GenericValidator } from 'src/app/validation/general-validation';

@Component({
  selector: 'app-adddashboard',
  templateUrl: './adddashboard.component.html'
})
export class AdddashboardComponent implements OnInit {

  errorMsg: string = '';
  DashbaordConfigDataForm: FormGroup;
  displayMessage: { [key: string]: string } = {};
  private genericValidator: GenericValidator;
  private validationMessages: { [key: string]: { [key: string]: string } };

  constructor(private authService: AuthService,  public dialogRef: MatDialogRef<AdddashboardComponent>, private form: FormBuilder, private dashboardservice: DashBoardService) {
    // Raise Validation message
    this.authService.getValidationMessage().subscribe(resp => {
      this.validationMessages = resp.DashbaordConfigDataForm;
      this.genericValidator = new GenericValidator(this.validationMessages);
    });
  }

  ngOnInit(): void {

    this.DashbaordConfigDataForm = this.form.group({
      DashboardName: []
    });

  }


  SaveDashboard() {

    if (this.DashbaordConfigDataForm.invalid) {
      this.DashbaordConfigDataForm.updateValueAndValidity();
      this.displayMessage = this.genericValidator.processMessages(this.DashbaordConfigDataForm, true);
      return;
    }

    this.CheckDashboardNameExist();

    this.dialogRef.close(this.DashbaordConfigDataForm.value.DashboardName);
  }

  // Close Icon event
  Close() {
    this.dialogRef.close();
  }

  // Cancel buton event
  Cancel() {
    this.dialogRef.close();
  }

  // CheckDashboardNameExist
  CheckDashboardNameExist() {
    this.dashboardservice.CheckDashboardNameExist(this.DashbaordConfigDataForm.value.DashboardName).subscribe(
      (result) => {
        if (result == 'True') {
          this.errorMsg = 'Dashboard Name is already Exist !!';
          return false;
        }
        else {
          return;
        }
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }


}
